import axios from "axios";
import { cca_config } from "@/plugins/cca-config";
import router from '@/router'
import store from '@/store'
import { installerComplement, terminerComplement } from '@/utils/complement-session'

// Lectures identiques lancées en même temps par plusieurs composants (listes des motifs, des diagnostics, types
// d'examens…) : une seule requête, chaque composant reçoit sa copie de la réponse (05/10/2026). Rien n'est gardé : une
// fois la réponse arrivée, l'appel suivant repart au serveur. Partagés : les GET, sauf ceux qui écrivent (reset, références
// de bon, mises à jour), et les seules lectures POST ci-dessous, à corps identique. Jamais : fichiers, requêtes annulables.
const GET_NON_PARTAGES = /(^|\/)(reset\/|bon\/reference|update_|fiche-consultation\/edit-content)/
const POST_LECTURES = ['/consultations/motifs/liste', '/consultations/list/antecedents', '/consultations/list/diagnosis']
const lecturesEnCours = {}
const copieReponse = reponse => Object.assign({}, reponse, { data: JSON.parse(JSON.stringify(reponse.data)) })

function lecturePartagee(lancer, cle, config) {
    const options = config || {}
    if ((options.responseType && options.responseType !== 'json') || options.cancelToken || options.signal) return lancer()
    if (!lecturesEnCours[cle]) {
        const enCours = lancer()
        lecturesEnCours[cle] = enCours
        const liberer = () => { if (lecturesEnCours[cle] === enCours) delete lecturesEnCours[cle] }
        enCours.then(liberer, liberer)
    }
    return lecturesEnCours[cle].then(copieReponse)
}

const enTetes = config => JSON.stringify((config && config.headers) || {})

export default () => {
    const auth_info = store.getters['authInfo']
    let token = ''

    if (auth_info) {
        token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
    }

    const localProxy = process.env.NODE_ENV === 'development' &&
        typeof window !== 'undefined' && window.location.port === '8280'
    const instance = axios.create({
        baseURL: localProxy ? `${window.location.origin}/clinique-api` : cca_config.C_URL + cca_config.C_URL_CLINIQUE_API,
        withCredentials: false,
        headers: {
            'Accept': "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
        },
    });

    installerComplement(instance)

    // Add a response interceptor
    instance.interceptors.response.use(
        response => response, // Return response if successful
        error => {
            // A short-lived MED-004 capability expiring must not destroy the login session.
            if (error.response && error.response.status === 401 &&
                !(error.config && (error.config.med_access_scoped || error.config.patient_profile_scoped))) {
                console.warn("Token expired for clinique. Logging out...");
                terminerComplement()
                localStorage.clear();
                router.push('/login'); // Redirect to login page
            }
            return Promise.reject(error);
        }
    );
    if (typeof instance.get === 'function') {
        const get = instance.get.bind(instance)
        instance.get = (url, config) => GET_NON_PARTAGES.test(String(url)) ? get(url, config)
            : lecturePartagee(() => get(url, config), ['GET', token, url, JSON.stringify((config && config.params) || {}), enTetes(config)].join('|'), config)
    }
    if (typeof instance.post === 'function') {
        const post = instance.post.bind(instance)
        instance.post = (url, data, config) => POST_LECTURES.indexOf(url) < 0 ? post(url, data, config)
            : lecturePartagee(() => post(url, data, config), ['POST', token, url, JSON.stringify(data === undefined ? null : data), enTetes(config)].join('|'), config)
    }
    return instance
};
